import React, { useContext } from "react";
import { isEmpty } from "lodash";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Icon } from "@iconify/react/dist/iconify.js";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "../../../components/ErrorMessage";
import { authContext } from "../../../context/AuthContext/AuthContext";
import { confirmRegisterValidation } from "../../../utils/validation/validation";

const ConfirmRegisterAuth = () => {
  const { handleConfirmRegister } = useContext(authContext);

  const { state } = useLocation();

  // Validation
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(confirmRegisterValidation),
  });

  if (isEmpty(state)) return <Navigate to="/auth/login" replace />;

  return (
    <>
      <SiteTitle title="تایید شماره موبایل" />

      <section className="auth bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="/assets/images/auth/auth-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="/assets/images/logo.svg" alt="" />
              </Link>
              <h4 className="mb-12">تایید شماره موبایل</h4>
              <p className="mb-32 text-secondary-light text-lg">
                لطفا کد ارسال شده به شماره موبایل{" "}
                <span className="text-primary fw-semibold">
                  {state.phoneNumber}
                </span>{" "}
                را وارد نمایید
              </p>
            </div>
            <form
              autoComplete="off"
              onSubmit={handleSubmit(handleConfirmRegister)}
            >
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:password-broken" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12 text-center"
                    placeholder="کد تایید"
                    {...register("verifyCode")}
                  />
                </div>

                <ErrorMessage message={errors.verifyCode?.message} />
              </div>
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                تایید
              </button>
              <div className="mt-32 text-center text-sm">
                <p className="mb-0">
                  حساب کاربری دارید؟{" "}
                  <Link
                    to="/auth/login"
                    className="text-primary-600 fw-semibold"
                  >
                    ورود به حساب کاربری
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConfirmRegisterAuth;
